import React from 'react';
// template components
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// images
import financialPlanningImage from './images/fdic-desktop.svg';
// styles
import { InformationalModuleStyled } from './styles';

export default () => {
  return (
    <InformationalModuleStyled
      // configs
      sectionId='investment-account-protection-financial-planning-2'
      moduleName='financial-planning-module'
      moduleVariation='A'
      reverseContent={false}
      // content
      subHeadingText={<>FDIC insurance designed for peace <WidowBlock>of mind</WidowBlock></>}
      // column content
      columnContentA={(
        <Typography disableBottomPadding>
          Northwestern Mutual also offers an FDIC&#45;insured bank deposit program &#40;&#34;NM FDIC Insured Deposit Program&#34;&#41; for cash held in a client&#39;s investment accounts with either NMIS or the Northwestern Mutual Wealth Management Company. If this&nbsp;
          <Link
            id='investment-account-protection-financial-planning-2-cash-sweep-link'
            variant='primaryDeemphasize'
            linkUrl='/cash-sweeps/'>
            cash sweep
          </Link>
          &nbsp;option is used for your investment account, this program provides FDIC coverage up to &#36;5 million &#40;&#36;10 million for joint accounts&#41; for each category of legal ownership. The NM FDIC Insured Deposit Program automatically transfers uninvested cash balances into one or more interest&#45;bearing bank account&#40;s&#41; each day. By automatically allocating your funds across multiple program banks, we&#39;re able to conveniently offer extended FDIC coverage.
        </Typography>
      )}
      // image props
      imageAltText='FDIC federal deposit insurance corporation coverage up to four million dollars'
      imageSrcDefault={financialPlanningImage}
    />
  );
};
